import { Tooltip } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import React from 'react';

import { styleTooltip } from '@/components/app-tooltip/AppTooltip';

interface MaxTagPlaceholderProps {
  omittedValues: any[];
  options: any[];
}

const MaxTagPlaceholder: React.FC<MaxTagPlaceholderProps> = ({ omittedValues, options }) => {
  const titles = omittedValues.map((item) => {
    const found = options.find((opt) => opt.value === item.value);
    return found?.originLabel || found?.label || item.value;
  });

  return (
    <Tooltip overlayStyle={{ pointerEvents: 'none' }} title={titles.join(', ')} {...styleTooltip}>
      <div className='custom-tooltip'>...</div>
    </Tooltip>
  );
};

export const renderMaxTagPlaceholder = (options: DefaultOptionType[]) => (omittedValues: any[]) => (
  <MaxTagPlaceholder omittedValues={omittedValues} options={options} />
);
